import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import { IxCard } from '../src/IxCard.js';
import '../src/ix-card.js';

describe('A11yTest', () => {
  it('passes the a11y audit', async () => {
    const el = await fixture<IxCard>(html`<ix-card></ix-card>`);

    await expect(el).shadowDom.to.be.accessible();
  });
});
